/** Registration role cards — ui-prototype-all/signup.html */

export const SIGNUP_ROLE_CARDS = [
  { id: 'GP', label: 'GP', desc: 'Fund Manager', backendRole: 'GP' },
  { id: 'LP', label: 'LP', desc: 'Investor', backendRole: 'LP' },
  { id: 'FA', label: 'FA', desc: 'Financial Advisor', backendRole: 'ServiceProvider', serviceSubtype: 'FA' },
  { id: 'Law Firm', label: 'Law Firm', desc: 'Legal Advisor', backendRole: 'ServiceProvider', serviceSubtype: 'Law Firm' },
  { id: 'Audit Firm', label: 'Audit Firm', desc: 'Accountant', backendRole: 'ServiceProvider', serviceSubtype: 'Audit Firm' },
  { id: 'Fund Formation', label: 'Fund Formation', desc: 'Fund Setup', backendRole: 'ServiceProvider', serviceSubtype: 'Fund Formation' },
  { id: 'Fund Admin', label: 'Fund Admin', desc: 'Administration', backendRole: 'ServiceProvider', serviceSubtype: 'Fund Admin' },
  { id: 'Escrow Bank', label: 'Escrow Bank', desc: 'Custodian Bank', backendRole: 'ServiceProvider', serviceSubtype: 'Escrow Bank' },
  { id: 'Startup', label: 'Startup', desc: 'Founder / Entrepreneur', backendRole: 'Startup' },
]

export const COUNTRY_OPTIONS = [
  { value: 'US', label: '🇺🇸 United States' },
  { value: 'GB', label: '🇬🇧 United Kingdom' },
  { value: 'CN', label: '🇨🇳 China' },
  { value: 'HK', label: '🇭🇰 Hong Kong SAR' },
  { value: 'SG', label: '🇸🇬 Singapore' },
  { value: 'JP', label: '🇯🇵 Japan' },
  { value: 'KR', label: '🇰🇷 South Korea' },
  { value: 'AE', label: '🇦🇪 UAE' },
  { value: 'CH', label: '🇨🇭 Switzerland' },
  { value: 'DE', label: '🇩🇪 Germany' },
  { value: 'FR', label: '🇫🇷 France' },
  { value: 'AU', label: '🇦🇺 Australia' },
  { value: 'CA', label: '🇨🇦 Canada' },
  { value: 'OT', label: '🌍 Other' },
]

/** @deprecated use PREFERRED_LANGUAGES + LanguageMultiSelect */
export const LANGUAGE_TAGS = [
  '🇨🇳 Chinese',
  '🇺🇸 English',
  '🇩🇪 Deutsch',
  '🇫🇷 Français',
  '🇪🇸 Español',
  '🇭🇰 Cantonese',
  '🇸🇦 العربية',
]

export const SECTOR_TAGS = [
  'Healthcare & Biotech',
  'Technology & AI',
  'Consumer & Retail',
  'Financial Services',
  'Real Estate',
  'Infrastructure & Energy',
  'EV & Clean Tech',
  'S-Fund / Secondary',
]

export const GEO_TAGS = [
  '🇨🇳 Tier 1 Cities (Beijing/Shanghai)',
  '🇨🇳 Tier 2 Cities',
  '🇭🇰 Hong Kong',
  'Greater Bay Area',
  'Pan-China (All Regions)',
]

export function resolveSignupRole(roleId) {
  return SIGNUP_ROLE_CARDS.find((r) => r.id === roleId) || SIGNUP_ROLE_CARDS[0]
}
